<template>
  <section class="container-full-5">
    <!-- En-tête Wallet -->
    <div class="bg-wallet">
      <div class="s11_mobile px-8 pt-5 pb-4">
        <h4 class="secondary-font font-bold mb-3">Solde total</h4>
        <div class="flex align-items-center gap-3">
          <h1 class="secondary-font text-8xl">{{ showBalance ? formatAmount(balance) : '*** ***' }}</h1>
          <h2 class="secondary-font text-5xl mt-2">F</h2>
          <div class="mt-2 ml-2 cursor-pointer" @click="showBalance = !showBalance">
            <img src="/public/icons/icon-eye-off.svg" class="size-medium icon-black" alt="" />
          </div>
        </div>

        <!-- Boutons d'action -->
        <div class="flex gap-5 mt-2">
          <router-link to="/front/wallet/utilisation" class="btn-supra lg flex-center flex-col align-items-center active">
            <div class="btn-supra-show-set btn-supra-animate mb-3">
              <div class="btn-supra-show px-2">
                <img src="/public/icons/icon-utilisation.svg" class="btn-supra-icon icon-white" alt="" />
              </div>
            </div>
            <span class="text-grey-700">Utilisation</span>
          </router-link>

          <router-link to="/front/profil/ma-souscription" class="btn-supra lg flex-center flex-col align-items-center">
            <div class="btn-supra-show-set btn-supra-animate mb-3">
              <div class="btn-supra-show">
                <img src="/public/icons/icon-souscription.svg" class="btn-supra-icon icon-white" alt="" />
              </div>
            </div>
            <span class="text-grey-700">Souscription</span>
          </router-link>

          <router-link to="/front/ma-carte" class="btn-supra lg flex-center flex-col align-items-center hide-mobile">
            <div class="btn-supra-show-set btn-supra-animate mb-3">
              <div class="btn-supra-show">
                <img src="/public/icons/icon-carte.svg" class="btn-supra-icon icon-white" alt="" />
              </div>
            </div>
            <span class="text-grey-700">Carte</span>
          </router-link>

          <router-link to="/front/profil" class="btn-supra lg flex-center flex-col align-items-center">
            <div class="btn-supra-show-set btn-supra-animate mb-3">
              <div class="btn-supra-show">
                <img src="/public/icons/icon-profil.svg" class="btn-supra-icon icon-white" alt="" />
              </div>
            </div>
            <span class="text-grey-700">Profil</span>
          </router-link>
        </div>
      </div>

      <!-- Carte aperçu -->
      <div class="s9_mobile" v-if="defaultCarte">
        <div class="card-carte-light">
          <div class="card-carte-floating right-bottom">
            <div>
              <h6 class="secondary-font font-bold">Solde utilisable</h6>
              <div class="flex align-items-center gap-2">
                <h1 class="secondary-font text-5xl">{{ showBalance ? formatAmount(defaultCarte.solde) : '***' }}</h1>
                <h2 class="secondary-font text-3xl">F</h2>
                <div>
                  <img src="/public/icons/icon-eye-off.svg" class="size-medium icon-white" alt="" />
                </div>
              </div>
            </div>
          </div>
          <img src="/public/images/carte_coop.png" class="card-carte-img" alt="Carte" />
        </div>
      </div>
    </div>

    <div class="clear-both h-30"></div>

    <!-- Widgets -->
    <div class="flex-mobile gap-7">

      <!-- Widget Revolving -->
      <div class="widget s6_mobile px-5 py-5 mb-5">
        <div class="flex gap-4 align-items-center">
          <div class="square-lg bg-black rounded-50 px-3 py-3 flex-center">
            <img src="/public/icons/icon-pouvoir.svg" class="icon-white" width="90%" alt="" />
          </div>
          <h4 class="secondary-font text-grey-800">Mon prochain revolving</h4>
        </div>
        <h1 class="secondary-font font-semibold text-4xl text-grey-900 my-5">
          {{ formatAmount(prochainRevolving) }} F
        </h1>

        <!-- Barre Bloqué -->
        <div class="h-35 rounded-100 position-relative" style="width: 100%; background-color: rgba(var(--color-black-rgb), 0.1);">
          <div class="widget-floating px-4 py-0 text-lg flex-right">{{ revolvingBloquePourcent }}%</div>
          <div
            class="h-100p flex align-items-center justify-content-left rounded-100 text-lg bg-color-1000 text-white"
            :style="{ width: revolvingBloquePourcent + '%' }"
          >
            <div class="px-4">Bloqué</div>
          </div>
        </div>
        <div class="h-10 mb-1"></div>

        <!-- Barre Utilisé -->
        <div class="h-35 rounded-100 position-relative" style="width: 100%; background-color: rgba(var(--color-black-rgb), 0.1);">
          <div class="widget-floating px-4 py-0 text-lg flex-right">{{ revolvingUtilisePourcent }}%</div>
          <div
            class="h-100p flex align-items-center justify-content-left rounded-100 text-lg bg-blue text-white"
            :style="{ width: revolvingUtilisePourcent + '%' }"
          >
            <div class="px-4">Utilisé</div>
          </div>
        </div>
        <div class="h-10 mb-1"></div>

        <!-- Barre Total -->
        <div class="h-35 rounded-100 position-relative" style="width: 100%; background-color: rgba(var(--color-black-rgb), 0.1);">
          <div class="widget-floating px-4 py-0 text-lg flex-right">100%</div>
          <div class="h-100p flex align-items-center justify-content-left rounded-100 text-lg bg-green-light" style="width: 100%;">
            <div class="px-4">Total</div>
          </div>
        </div>
      </div>

      <!-- Widget Marketplace -->
      <div class="widget s6_mobile px-5 py-5 mb-5" style="background: linear-gradient(135deg, rgba(var(--primary-color-rgb), 0.9), rgba(var(--color-black-rgb), 0.9));">
        <div class="flex gap-4 align-items-center">
          <div class="square-lg bg-white rounded-50 px-3 py-3 flex-center">
            <img src="/public/icons/icon-market.svg" class="icon-black" width="90%" alt="" />
          </div>
          <h4 class="secondary-font text-white">Marketplace</h4>
        </div>
        <div class="flex flex-col align-items-center gap-3">
          <router-link to="/front/market">
            <h4 class="secondary-font text-white mt-5">Découvrir le market</h4>
          </router-link>
        </div>
      </div>

      <!-- Widget Sécurité -->
      <div class="widget s8_mobile text-center px-5 pt-7 pb-5 mb-5">
        <router-link to="/front/profil/changer-pin">
          <img src="/public/icons/icon-securite-glossy.png" width="30%" alt="" />
          <h4 class="secondary-font text-grey-800 mt-6 mb-2">Sécurité</h4>
          <p class="text-lg line-height-1-5 text-grey-700 text-center">
            Activez la double authentification pour sécuriser votre compte.
          </p>
        </router-link>
      </div>
    </div>

    <div class="h-10"></div>

    <!-- En-tête Transactions -->
    <div class="s20 flex align-items-center mb-4">
      <h3 class="s10 secondary-font gap-4 mt-2 text-grey-800">Transactions</h3>
      <router-link to="/front/wallet/utilisation" class="s10 text-right">
        <h5 class="secondary-font text-primary-color">+Plus</h5>
      </router-link>
    </div>

    <!-- Liste de Transactions récentes -->
    <div class="s20 mt-2">
      <div
        v-for="tx in recentTransactions"
        :key="tx.id"
        class="flex gap-6 mb-4 cursor-pointer"
        @click="goToTransaction(tx.id)"
      >
        <div class="square-xl px-4 py-4" style="background-color: rgba(0, 185, 172, 0.08);">
          <img src="/public/icons/icon-trans-recharger.svg" width="100%" class="icon-neutral" alt="" />
        </div>
        <div class="s13 mt-2">
          <h6 class="secondary-font font-semibold mb-1">{{ tx.libelle }}</h6>
          <p class="secondary-font font-semibold text-sm text-grey-600 mb-2">
            {{ formatDateTransaction(tx.date) }} - {{ tx.reference }}
          </p>
        </div>
        <h5 class="s5 secondary-font text-right mt-2" :class="tx.type === 'credit' ? 'text-green' : ''">
          {{ tx.type === 'credit' ? '+' : '-' }} {{ formatAmount(tx.montant) }} F
        </h5>
      </div>

      <div v-if="recentTransactions.length === 0 && !loading" class="text-grey-600 mb-4">
        Aucune transaction récente
      </div>
    </div>

    <div v-if="loading" class="flex-center py-7">
      <p class="secondary-font text-grey-600">Chargement...</p>
    </div>

    <div class="clear-both h-60"></div>

  </section>
</template>

<script lang="ts">
import { defineComponent, ref, computed, onMounted } from 'vue'
import { useRouter } from 'vue-router'
import walletService, { type WalletTransaction } from '@/services/walletService'
import carteService, { type Carte } from '@/services/carteService'
import profilService, { type Souscription } from '@/services/profilService'
import { formatAmount } from '@/utils/formatters'

export default defineComponent({
  name: 'WalletDashboard',
  setup() {
    const router = useRouter()
    const loading = ref(true)
    const showBalance = ref(true)
    const balance = ref(0)
    const defaultCarte = ref<Carte | null>(null)
    const souscription = ref<Souscription | null>(null)
    const recentTransactions = ref<WalletTransaction[]>([])

    const prochainRevolving = computed(() => {
      if (!souscription.value?.details?.length) return souscription.value?.revolving || 0
      const pending = souscription.value.details.find(d => d.statut === 'pending' || !d.actif)
      return pending?.pouvoir_achat || souscription.value.revolving || 0
    })

    const revolvingBloquePourcent = computed(() => {
      if (!souscription.value) return 0
      const total = souscription.value.revolving || 1
      const bloque = (souscription.value.prelevement_montant || 0)
      return Math.min(100, Math.round((bloque / total) * 100))
    })

    const revolvingUtilisePourcent = computed(() => {
      if (!souscription.value) return 0
      const total = souscription.value.revolving || 1
      const utilise = (souscription.value.utilisation_total || 0)
      return Math.min(100, Math.round((utilise / total) * 100))
    })

    function formatDateTransaction(dateStr: string): string {
      if (!dateStr) return '-'
      const date = new Date(dateStr)
      if (isNaN(date.getTime())) return '-'
      const mois = [
        'Jan.', 'Fév.', 'Mars', 'Avr.', 'Mai', 'Juin',
        'Juil.', 'Août', 'Sept.', 'Oct.', 'Nov.', 'Déc.'
      ]
      const jour = date.getDate().toString().padStart(2, '0')
      const moisNom = mois[date.getMonth()]
      const annee = date.getFullYear()
      const heures = date.getHours().toString().padStart(2, '0')
      const minutes = date.getMinutes().toString().padStart(2, '0')
      return `${jour} ${moisNom} ${annee} à ${heures}:${minutes}`
    }

    function goToTransaction(id: number) {
      router.push(`/front/wallet/transaction/${id}`)
    }

    async function loadData() {
      loading.value = true
      try {
        const [balanceRes, cartesRes, souscriptionRes, transactionsRes] = await Promise.all([
          walletService.getBalance(),
          carteService.getCartes(),
          profilService.getSouscription(),
          walletService.getTransactions({ per_page: 10 })
        ])

        if (balanceRes.data) balance.value = balanceRes.data.balance || 0
        if (cartesRes.data && Array.isArray(cartesRes.data)) {
          defaultCarte.value = cartesRes.data.find((c: Carte) => c.parDefaut) || cartesRes.data[0] || null
        }
        if (souscriptionRes.data) souscription.value = souscriptionRes.data
        if (transactionsRes.data) {
          recentTransactions.value = transactionsRes.data.data || []
        }
      } catch (e) {
        // silencieux
      } finally {
        loading.value = false
      }
    }

    onMounted(() => {
      loadData()
    })

    return {
      loading,
      showBalance,
      balance,
      defaultCarte,
      souscription,
      recentTransactions,
      prochainRevolving,
      revolvingBloquePourcent,
      revolvingUtilisePourcent,
      formatAmount,
      formatDateTransaction,
      goToTransaction
    }
  }
})
</script>

<style scoped>
.cursor-pointer {
  cursor: pointer;
}
</style>
